<template>
  <a href="#" @click.prevent="twitterLink(url, {title})" class="btn-share">
    <svg width="23px" height="22px" viewBox="0 0 23 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>twitter copy</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="twitter-copy">
            <circle id="Oval" fill="#3C3C3C" cx="11.6666667" cy="11" r="11"></circle>
            <path d="M17.3382292,8.82031551 C17.3382292,12.1562139 14.6569792,16 9.75760417,16 C8.24635417,16 6.84479167,15.5844556 5.66666667,14.8687957 C5.88197917,14.8918815 6.08916667,14.8995768 6.30854167,14.8995768 C7.55572917,14.8995768 8.70135417,14.4994229 9.61541667,13.8222393 C8.44541667,13.7991535 7.46229167,13.0719508 7.12510417,12.071566 C7.53541667,12.1292805 7.90510417,12.1292805 8.32760417,12.0253944 C7.10885417,11.7906887 6.19479167,10.7749134 6.19479167,9.54751828 L6.19479167,9.51673721 C6.54822917,9.70527126 6.96260417,9.82070027 7.39729167,9.8360908 C6.65501123,9.36846354 6.20958217,8.57962397 6.21104167,7.7352828 C6.21104167,7.26587149 6.34104167,6.83493651 6.57260417,6.46171604 C7.88479167,7.99307426 9.85510417,8.99345902 12.0651042,9.10119277 C11.6872917,7.38899577 13.0401042,6 14.6651042,6 C15.4329167,6 16.1235417,6.30396306 16.6110417,6.79646018 C17.2122917,6.68872643 17.7891667,6.47710658 18.3010417,6.18853405 C18.1019792,6.77337437 17.6835417,7.26587149 17.1310417,7.57752982 C17.6672917,7.52366295 18.1872917,7.3813005 18.6666667,7.18507118 C18.3051042,7.6891112 17.8501042,8.13543671 17.3301042,8.49326664 C17.3382292,8.60100038 17.3382292,8.71258176 17.3382292,8.82031551 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero"></path>
        </g>
    </g>
</svg>
  </a>
</template>

<script>
import objectToGetParams from '../../utils/objectToGetParams'
export default {
  name: 'twitter',
  methods: {
    twitterLink (url, { title }) {
      this.$emit('shared')
      window.open(
        'https://www.twitter.com/share' +
            objectToGetParams({
              url: url,
              text: title
            }),
        '__blank'
      )
    }
  },
  components: {},
  computed: {
    baseUrl() {
      return process.env.BASE_URL
    }
  },
  props: {
    url: {
      required: true,
      type: String
    },
    title: {
      required: false,
      type: String
    },
    scale: {
      required: false,
      type: String
    }
  }
}
</script>
